var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowthChartDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.875C12.5 20.496 11.988 21 11.357 21L5.643 21C5.012 21 4.5 20.496 4.5 19.875L4.5 4C4.5 3.73478 4.60536 3.48043 4.79289 3.29289C4.98043 3.10536 5.23478 3 5.5 3L11.357 3C11.988 3 12.5 3.504 12.5 4.125L12.5 19.875Z",
    fill: "#A461D8",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6L9.5 6",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12L9.5 12",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18L9.5 18",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3L17.5 3",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3L19.5 21",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21L17.5 21",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 8.25C10.286 8.25 9.9502 8.58579 9.9502 9C9.9502 9.41421 10.286 9.75 10.7002 9.75L10.7002 8.25ZM10.7002 9.75L13.3002 9.75L13.3002 8.25L10.7002 8.25L10.7002 9.75Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 14.25C10.286 14.25 9.9502 14.5858 9.9502 15C9.9502 15.4142 10.286 15.75 10.7002 15.75L10.7002 14.25ZM10.7002 15.75L13.3002 15.75L13.3002 14.25L10.7002 14.25L10.7002 15.75Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30029 5.25C7.88608 5.25 7.55029 5.58579 7.55029 6C7.55029 6.41421 7.88608 6.75 8.30029 6.75V5.25ZM8.30029 6.75H13.3003V5.25H8.30029V6.75Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30029 11.25C7.88608 11.25 7.55029 11.5858 7.55029 12C7.55029 12.4142 7.88608 12.75 8.30029 12.75V11.25ZM8.30029 12.75H13.3003V11.25H8.30029V12.75Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30029 17.25C7.88608 17.25 7.55029 17.5858 7.55029 18C7.55029 18.4142 7.88608 18.75 8.30029 18.75V17.25ZM8.30029 18.75H13.3003V17.25H8.30029V18.75Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthChartDark);
export default __webpack_public_path__ + "static/media/growth-chart-dark.5c0c7285a436592170fdb6a26cb9ec8f.svg";
export { ForwardRef as ReactComponent };